import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    initShopifyCollectionsDetailsUpdate,
    syncShopifyCollectionsList
} from "../../../common/services/cloud-function-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {searchShopifyCollections, updateSingleShopifyCollection} from "../../services/shopify-collection-data-service";
import {searchPromptsWithSearchCriteria} from "../../../content/services/prompt-data-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {
    EyeIcon,
    EyeSlashIcon,
    WrenchScrewdriverIcon
} from "@heroicons/react/24/solid";
import {generateJsonContent} from "../../../common/services/open-ai-service";
import {
    prepareCollectionDescriptionMetaPromptMessages,
} from "../../../design/utils/open-ai-prompt-util";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import AddEditImageMedia from "../../../marketing/components/media-editor/add-edit-image-media";

const defaultFilterCriteria = {
    toneOfVoice: '',
}

const ShopifyCollectionList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [collectionsList, setCollectionsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [promptsList, setPromptsList] = useState(null);
    const [metaLines, setMetaLines] = useState(null);
    const [inputTexts, setInputTexts] = useState(null);
    const [selectedCollectionMap, setSelectedCollectionMap] = useState(null);
    const [selectedCollection, setSelectedCollection] = useState(null);
    const [syncUpdateInProgress, setSyncUpdateInProgress] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const [showCollectionWithImage, setShowCollectionWithImage] = useState(false);

    useEffect(() => {
        if (initialStep) {
            setInputTexts([]);
            setSelectedCollectionMap({});
            getPromptList();
            getShopifyCollectionList();
            setInitialStep(false);
        }
    }, [initialStep]);

    const getPromptList = async () => {
        const searchCriteriaList = [
            {field: 'type', condition: '==', value: 'Product Blog'},
            {field: 'status', condition: '==', value: 'Enabled'}
        ];

        const promptListResult = await searchPromptsWithSearchCriteria(searchCriteriaList);
        setPromptsList(promptListResult);
    }

    const getShopifyCollectionList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];
        const collectionListResult = await searchShopifyCollections(searchCriteriaList);

        setCollectionsList(_.orderBy(collectionListResult, ['title'], ['asc']));
        setDataFetchInProgress(false);
    }

    const startCollectionSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncShopifyCollectionsList();
        await getShopifyCollectionList();
        setDataFetchInProgress(false);
    }

    const startShopifyCollectionsDetailsUpdate = async () => {
        setDataFetchInProgress(true);
        await initShopifyCollectionsDetailsUpdate();
        await getShopifyCollectionList();
        setDataFetchInProgress(false);
    }

    const handleFilterCriteriaChanges = (event) => {
        const {name, value, type} = event.target;
        const existingFilterCriteria = {...filterCriteria};

        if (type === 'checkbox') {
            existingFilterCriteria[name] = !existingFilterCriteria[name];
        } else if (type === 'number') {
            existingFilterCriteria[name] = _.parseInt(value);
        } else {
            existingFilterCriteria[name] = value;
        }

        setFilterCriteria(existingFilterCriteria);
    }

    const handleCollectionDetailChange = (collection, collectionIndex) => {
        const existingCollectionsList = [...collectionsList];
        existingCollectionsList[collectionIndex] = collection;

        // console.log('collection', collection);

        setCollectionsList(existingCollectionsList);
        saveCollectionDetail(collection);
    }

    /*const processMetaLines = (existingMetaLine) => {
        if (existingMetaLine.metaType === 'seoTitle') {
            existingMetaLine.metaLabel = 'Meta Title';
        } else if (existingMetaLine.metaType === 'seoDescription') {
            existingMetaLine.metaLabel = 'Meta Description';
        } else if (existingMetaLine.metaType === 'excerpt') {
            existingMetaLine.metaLabel = 'Excerpt';
        }

        if (existingMetaLine.metaType) {
            existingMetaLine.newType = existingMetaLine.metaType;
            existingMetaLine.isMeta = true;
        }
    }*/

    /*const handleRemoveMetaLine = (metaLineIndex) => {
        const existingMetaLines = [...metaLines];
        existingMetaLines.splice(metaLineIndex, 1);
        setMetaLines(existingMetaLines);
    }*/

    const handleAddMetaLine = (newMetaLines, collection, collectionIndex) => {
        collection.metaLines = newMetaLines;
        const existingCollectionsList = [...collectionsList];
        existingCollectionsList[collectionIndex] = collection;
        setCollectionsList(existingCollectionsList);

        saveCollectionDetail(collection);
    }

    const handleShowHideSectionContent = (collection) => {
        const existingSelectedCollectionMap = {...selectedCollectionMap};
        existingSelectedCollectionMap[collection.id] = !existingSelectedCollectionMap[collection.id];
        setSelectedCollectionMap(existingSelectedCollectionMap);
    }

    const saveCollectionDetail = async (collection) => {
        setDataFetchInProgress(true);
        await updateSingleShopifyCollection(collection);
        setDataFetchInProgress(false);
    }

    const generateCollectionMetaDetails = async (collection, collectionIndex) => {
        setSelectedCollection(collection);

        const metaDetail = {
            toneOfVoice: 'Catchy',
        };

        const promptMessages = prepareCollectionDescriptionMetaPromptMessages(collection, metaDetail);
        const contentDetail: any = await generateJsonContent(promptMessages);

        if (contentDetail) {
            if (_.isArray(contentDetail)) {
                collection.content = contentDetail[0];
            } else if (_.isObject(contentDetail)) {
                collection.content = contentDetail;
            }
        }

        const replaceTextList = [' | LeafyOrb', ' - LeafyOrb', ' | Leafy Orb', ' - Leafy Orb', ' | Leafyorb', ' - Leafyorb', ' | Leafy orb', ' - Leafy orb'];

        if (collection.content) {
            _.forEach(replaceTextList, (replaceText) => {
                if (collection.content?.metaTitle.includes(replaceText)) {
                    collection.content.metaTitle = collection.content.metaTitle.replace(replaceText, '');
                }
            });
        }

        const existingCollectionsList = [...collectionsList];
        existingCollectionsList[collectionIndex] = collection;
        setCollectionsList(existingCollectionsList);

        await saveCollectionDetail(collection);

        setSelectedCollection(null);
    }

    const toggleShowDescription = (e) => {
        setShowDescription(!showDescription);
    }

    const toggleShowCollectionWithImage = (e) => {
        setShowCollectionWithImage(!showCollectionWithImage);
    }

    return (
        <>
            <div className="flex justify-center">
                <div className="w-full flex justify-between">

                    <div className="flex items-center">
                        <div className={'text-lg font-bold text-gray-500'}>
                            Shopify Collections
                        </div>

                        <div className="mx-2">
                            <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                        </div>

                        <button onClick={toggleShowDescription}
                                className="button-gray-outline flex items-center justify-center">
                            <div className={'pl-3'}>Description</div>

                            {showDescription &&
                                <div className="p-2">
                                    <EyeIcon className="h-6 w-6"/>
                                </div>
                            }

                            {!showDescription &&
                                <div className="p-2">
                                    <EyeSlashIcon className="h-6 w-6"/>
                                </div>
                            }
                        </button>

                        <button onClick={toggleShowCollectionWithImage}
                                className="button-gray-outline flex items-center justify-center ml-2">
                            <div className={'pl-3'}>Image</div>

                            {showCollectionWithImage &&
                                <div className="p-2">
                                    <EyeIcon className="h-6 w-6"/>
                                </div>
                            }

                            {!showCollectionWithImage &&
                                <div className="p-2">
                                    <EyeSlashIcon className="h-6 w-6"/>
                                </div>
                            }
                        </button>
                    </div>

                    <div className="ml-2 w-3/4 flex items-center justify-end">
                        {/*<div className={'w-1/2'}>
                            <RenderFields
                                parentForm={filterCriteria}
                                handleDetailChanges={handleFilterCriteriaChanges}
                                fieldList={_.groupBy(COLLECTION_INPUT_FIELDS, 'group')['meta']}
                                enableEdit={true}
                                noFieldLabel={true}
                                fieldClassName={'w-full'}/>
                        </div>*/}

                        <div className={'w-1/2 flex items-center justify-end'}>
                            <button
                                className="button-gray px-4 py-2 flex items-center justify-center"
                                onClick={startCollectionSyncProcess}>
                                <span>Sync Shopify Collections</span>
                            </button>

                            <button
                                className="button-green px-4 py-2 ml-2 flex items-center justify-center"
                                onClick={startShopifyCollectionsDetailsUpdate}>
                                <span>Update Collection Details</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <div className="flex justify-center">

                <div
                    className="shopify-collections-table-container w-full mt-4 overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={collectionsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Collections'}/>

                    {collectionsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white">S.No</th>
                                <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white">Image</th>
                                <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white text-left">
                                    Collection
                                </th>
                                <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white text-left">
                                    Meta Title
                                </th>
                                {showDescription &&
                                    <>
                                        <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white text-left">
                                            Meta Description
                                        </th>
                                        <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white text-left">
                                            Page Description
                                        </th>
                                    </>
                                }
                                <th className="p-2 border border-gray-400 sticky -top-1 bg-gray-400 text-white text-center w-64">
                                    Action
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {collectionsList?.map((collection, collectionIndex) => (
                                <React.Fragment key={`row-${collectionIndex}`}>
                                    {(showCollectionWithImage || (!showCollectionWithImage && !collection?.image?.url)) &&
                                        <tr className="border border-gray-400">
                                            <td className="p-2 border border-gray-400 m-auto w-16">
                                                <div className="flex justify-center">
                                                    {collectionIndex + 1}
                                                </div>
                                            </td>

                                            <td className="p-2 border border-gray-400 m-auto w-16">
                                                <div className="flex justify-center">
                                                    <ProductImageSmall imageUrl={collection?.image?.url}/>
                                                </div>
                                            </td>

                                            <td className={`p-2 border border-gray-400 m-auto`}>

                                                <div className={`flex justify-between items-center`}>
                                                    <div className={'flex justify-start items-center'}>
                                                        <div
                                                            className={`p-1 w-14 text-center font-semibold ${collection?.productsCount > 0 ? 'button-sky-outline' : 'button-red-outline'}`}>
                                                            {collection?.productsCount}
                                                        </div>

                                                        <div className={'ml-4'}>
                                                            <div className={'text-gray-800'}>
                                                                {collection.title}
                                                                {collection?.isDeleted &&
                                                                    <span
                                                                        className={'text-sm text-red-500 ml-2'}>Deleted</span>}
                                                            </div>
                                                            <div>
                                                                <a href={`https://leafyorb.com/collections/${collection?.handle}`}
                                                                   target={'_blank'}
                                                                   className={'text-blue-500'}>{collection['handle']}</a>
                                                            </div>
                                                        </div>

                                                        <div className={'ml-4'}>
                                                            <CopyDataToClipboard value={collection.title}/>
                                                        </div>
                                                    </div>

                                                </div>

                                                {/*{selectedCollectionMap[collection?.id] && collection?.metaLines?.length > 0 &&

                                            <CollectionMetaList
                                                metaLines={collection?.metaLines}
                                                handleCollectionDetailChange={() => {
                                                    handleCollectionDetailChange(collection, collectionIndex);
                                                }}/>
                                        }*/}
                                            </td>

                                            <td className="p-2 border border-gray-400 m-auto">
                                                {collection?.content?.metaTitle}
                                            </td>

                                            {showDescription &&
                                                <>
                                                    <td className="p-2 border border-gray-400 m-auto">
                                                        {collection?.content?.metaDescription}
                                                    </td>

                                                    <td className="p-2 border border-gray-400 m-auto">
                                                        {collection?.content?.pageIntroduction}
                                                    </td>
                                                </>
                                            }

                                            <td className="p-2 border border-gray-400 m-auto">
                                                <div className={'flex justify-center items-center'}>

                                                    {selectedCollection?.id === collection?.id &&
                                                        <div className="mx-2">
                                                            <ShowProgressSpinner
                                                                sizeClass={'h-6 w-6'}
                                                                dataFetchInProgress={true}/>
                                                        </div>
                                                    }

                                                    <div>
                                                        {!collection?.content?.metaTitle && !collection?.isDeleted &&
                                                            <button
                                                                className={`button-sky-outline text-sm px-1 py-1 my-1 flex items-center justify-center 
                                                            ${selectedCollection?.id === collection?.id ? 'cursor-not-allowed button-gray-outline-disabled' : ''}`}
                                                                disabled={selectedCollection?.id === collection?.id}
                                                                onClick={() => {
                                                                    generateCollectionMetaDetails(collection, collectionIndex)
                                                                }}>
                                                                <WrenchScrewdriverIcon className="h-4 w-4 ml-1"/>
                                                                <span className={'mx-1'}>Generate Meta</span>
                                                            </button>
                                                        }

                                                        <div className={'flex justify-between items-center'}>
                                                            <div className={''}>
                                                                <AddEditImageMedia
                                                                    isAddImageMedia={true}
                                                                    isCollection={true}
                                                                    mediaFor={collection}
                                                                    cssClass={'button-green-outline text-sm px-2 py-1 flex items-center justify-center'}
                                                                    refreshImageMediaList={() => {
                                                                    }}/>
                                                            </div>

                                                            <div className="ml-2">
                                                                <CopyDataToClipboard
                                                                    sizeClass={'px-0 py-1'}
                                                                    value={JSON.stringify(collection, null, 2)}/>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyCollectionList
